import React, { Component } from "react";
import AlertConfirmation from "./confirmDelete.js";
import GroupAPI from "../api/GroupAPI";
import GroupsList from "./groups/GroupsList";
import GroupEdit from "./groups/GroupEdit";

import "../style.css";

class Groups extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groups: [],
      group: null
    };
  }

  // Load all groups for a display
  componentDidMount() {
    this.loadGroups();
  }

  loadGroups = () => {
    GroupAPI.getGroups().then(groups => {
      this.setState({
        groups: groups
      });
    });
  };

  handleGroupChange = event => {
    let group = this.state.group;
    const value = event.target.value;
    group[event.target.id] = value;
    this.setState({
      group: group
    });
  };

  // Load a group get by id for the update
  getGroupsById = id => {
    GroupAPI.getGroup(id).then(group => {
      this.setState({
        group: group
      });
    });
    this.setState({
      action: "update"
    });
  };

  initGroup = () => {
    const group = {
      name: ""
    };
    this.setState({
      group: group,
      action: "create"
    });
  };

  // Determine if want tou create or update a group
  insertGroup = () => {
    if (this.state.action === "create") {
      this.createGroup();
    } else if (this.state.action === "update") {
      this.updateGroup();
    } else {
      return;
    }
  };

  // Update a group
  updateGroup() {
    GroupAPI.updateGroup(this.state.group.id, this.state.group).then(result => {
      this.setState({
        group: null
      });
      this.loadGroups();
    });
  }

  createGroup() {
    GroupAPI.createGroup(this.state.group).then(result => {
      this.setState({
        group: null
      });
      this.loadGroups();
    });
  }

  deleteGroup(id) {
    GroupAPI.deleteGroup(id).then(result => {
      this.loadGroups();
    });
  }

  confirmDelete = (id, groupName) => {
    const deleteHandler = onClose => {
      this.deleteGroup(id);
      onClose();
    };
    AlertConfirmation.confirmDelete(
      deleteHandler,
      `Do you want to delete the group ${groupName} ?`
    );
  };

  render() {
    return (
      <div className="groups-div">
        <GroupsList groups={this.state.groups}
                    onEdit={this.getGroupsById}
                    onDelete={this.confirmDelete}/>
        <GroupEdit group={this.state.group}
                   onEdit={this.handleGroupChange}
                   onSubmit={this.insertGroup}
                   onCreate={this.initGroup}/>
      </div>
    );
  }
}

export default Groups;



// WEBPACK FOOTER //
// ./src/components/Groups.js